import React from "react";
import { MeetingInstance, MeetingPurpose } from "@services/meetings/types";
import {
  Build,
  GppBad,
  Group,
  Healing,
  QuestionMark,
  RadioButtonUnchecked,
  VerifiedUser,
} from "@mui/icons-material";
import { AuthenticatedUser } from "@services/user/types";
import { canViewTicket } from "@common/utils/user";
import { isMeetingInSchedule } from "@common/utils/meetings";

export const MeetingIconPurpose = (props: { purpose?: MeetingPurpose }) => {
  switch (props.purpose) {
    case MeetingPurpose.RegularMeeting:
      return <Group />;
    case MeetingPurpose.CertificationOfUnmanaged:
      return <GppBad />;
    case MeetingPurpose.CertificationOfManaged:
      return <VerifiedUser />;
    case MeetingPurpose.Maintenance:
      return <Build />;
    case MeetingPurpose.Sweep:
      return <Healing />;
    case MeetingPurpose.Other:
      return <RadioButtonUnchecked />;
    default:
      return <QuestionMark />;
  }
};

export enum MeetingTabs {
  Realtime = "Realtime",
  Tickets = "Tickets",
  Monitoring = "Monitoring",
}

export const getMeetingTabs = (
  user: AuthenticatedUser,
  meeting: MeetingInstance,
  meetingId: string | undefined
) => {
  const tabs = [
    { name: MeetingTabs.Realtime },
    { name: MeetingTabs.Tickets, disabled: !canViewTicket(user) },
    { name: MeetingTabs.Monitoring, disabled: isMeetingInSchedule(meeting) },
  ];

  return meetingId?.includes("|") ? tabs.slice(0, 1) : tabs;
};
